import { render, staticRenderFns } from "./FamilySelectComponent.vue?vue&type=template&id=63ac3e43&"
import script from "./FamilySelectComponent.vue?vue&type=script&lang=js&"
export * from "./FamilySelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports